import useLoadExports from "hooks/useLoadExports"
import {useSelector} from "react-redux"
import {getExports} from "redux/export.selector"

const useUpdatedExports = (loadDestination: boolean) => {
  useLoadExports(loadDestination)
  return useSelector(getExports)
}

export default useUpdatedExports